import React, { useState, useEffect } from "react";
import Modal from "components/Modal";
import icInfo from 'static/ic-info-text.png';
import icClose from 'static/ic-close.png';
import btnFusionActive from 'static/btn-fusion-active.png';
import btnFusionInActive from 'static/btn-fusion-inactive.png';
import imgBuc from 'static/buc.png';
import bgMonth from 'static/bg-month.png';
import styled from 'styled-components';
import Carousel from 'react-multi-carousel';
import "react-multi-carousel/lib/styles.css";
import "./puzz.scss"
import { DROP_TITLE, MODAL_TYPE, NATIVE_ACTION } from "helpers/constants";
import { magicRewardReception } from "services";
import connect from "react-redux/lib/connect/connect";
import ModalFusion from "./ModalFusion";
import ModalUnexpected from "components/ModalUnexpected";
import moment from "moment";
import { compareMonth, isAfter } from "helpers/helpers";
import DropBanner from "components/DropBanner";
import ModalInfo from "./ModalInfo";
import { handleNativeAction } from "../../../helpers/nativeActions";

const Month = styled.p`
    background-image: url(${bgMonth});
    background-repeat: no-repeat;
    background-size: contain;
    align-content: center;
    background-position: center;
    with: 7.375rem;
    height: 1.75rem;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: 0.4000000059604645px;
    text-transform: uppercase;
    padding-left: .5rem;
    position: absolute;
    top: 1rem;
    right: 0;
    left: 0;
    margin-right: auto;
    margin-left: auto;
}
`
const Container = styled.div`
    height: 16rem`

const Puzzle = styled.div`
    background-repeat:no-repeat;
    background-size: contain;
    width: 9rem;
    height: 9rem;
`
const styleCenter = {
    position: "absolute",
    right: 0,
    left: 0,
    marginRight: "auto",
    marginLeft: "auto"
}

const Content = styled.div`
    font-size: .875rem;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.02em;
    text-align: left;
`

const Loading = styled.div`
    position: absolute;
    float: none;
    background: #ffffff50;
    padding-top: 20vh;
`

const Spinner = styled.div`
    border: 3px solid red;
    border-right-color: transparent;
`

const Image = ({ magicInMonth, fusion }) => {
    const piece1 = magicInMonth.find(item => item.magicType === "1");
    const piece2 = magicInMonth.find(item => item.magicType === "2");
    const piece3 = magicInMonth.find(item => item.magicType === "3");
    const piece4 = magicInMonth.find(item => item.magicType === "4");
    const isActive = piece1 && piece2 && piece3 && piece4;
    const sourceImage = piece1 ? piece1.magicPicture :
        piece2 ? piece2.magicPicture :
            piece3 ? piece3.magicPicture :
                piece4 ? piece4.magicPicture : null;
    return (
        <div className="text-center relative h-[100vh]">
            <Month>Tháng  {moment(magicInMonth[0].magicMonth, "MM/YYYY").month() + 1}</Month>
            <div className="d-flex justify-content-center">
                <div>
                    {/* Manh 1 */}
                    <Puzzle className={`piece1 ${piece1 === undefined ? "grayscale" : ""}`}
                        style={{
                            backgroundImage: `url(${sourceImage})`,
                            backgroundPosition: "4.5rem 4.5rem",
                            marginRight: `${piece1 === undefined && "0.5px"}`,
                            marginBottom: `${piece1 === undefined && "0.5px"}`
                        }} />
                    {/* Manh 3 */}
                    <Puzzle className={`piece3 ${piece3 === undefined ? "grayscale" : ""}`}
                        style={{
                            backgroundImage: `url(${sourceImage})`,
                            backgroundPosition: "4.5rem -4.5rem",
                            marginRight: `${piece3 === undefined && "0.5px"}`,
                            marginTop: `${piece3 === undefined && "0.5px"}`
                        }} />
                </div>
                <div>
                    {/* Manh 2 */}
                    <Puzzle className={`piece2 ${piece2 === undefined ? "grayscale" : ""}`}
                        style={{
                            backgroundImage: `url(${sourceImage})`,
                            backgroundPosition: "-4.5rem 4.5rem",
                            marginLeft: `${piece2 === undefined && "0.5px"}`,
                            marginBottom: `${piece2 === undefined && "0.5px"}`
                        }} />
                    {/* Manh 4 */}
                    <Puzzle className={`piece4 ${piece4 === undefined ? "grayscale" : ""}`}
                        style={{
                            backgroundImage: `url(${sourceImage})`,
                            backgroundPosition: "-4.5rem -4.5rem",
                            marginLeft: "0.5px",
                            marginLeft: `${piece4 === undefined && "0.5px"}`,
                            marginTop: `${piece4 === undefined && "0.5px"}`
                        }} />
                </div>
            </div>
            <img src={isActive ? btnFusionActive : btnFusionInActive} style={{ ...styleCenter, position: 'absolute', top: '16rem', width: "8.5rem" }} alt="btn-fusion" onClick={() => isActive && fusion()} />
        </div>
    )
}


const PuzzleStorage = ({ isOpen, onCloseModal, gameCode, magicRewardReception, historyList }) => {
    const [magicList, setMagicList] = useState([]);
    const [currentMonthIndex, setCurrentMonthIndex] = useState(0); // current month index to get real month from selected slide
    const [modal, openModal] = useState(false);
    const [configUnexpected, setConfigModal] = useState({ message: "Ghép mảnh thất bại, bạn vui lòng thử lại sau", btnLabel: "Đóng", callback: () => openModal(null) });
    const [fusionData, setFustionData] = useState({})
    const [loading, setLoading] = useState(false);
    const monthList = [];
    useEffect(() => {
        if (isOpen) {
            const filterList = historyList.filter(item => item.serviceResCd === "");
            if (filterList.length > 0) {
                setMagicList(filterList);
            } else {
                setConfigModal({
                    message: "Hiện tại bạn không có mảnh ghép nào, quay thưởng ngay để thu thập các mảnh ghép nhé",
                    btnLabel: "Quay thưởng ngay",
                    callback: () => {
                        onCloseModal();
                        openModal(null);
                    }
                });
                openModal(MODAL_TYPE.UN_EXPECTED);
            }


        }
    }, [isOpen, historyList]);
    magicList.forEach(item => {
        // Check month in the past, reject
        // Only add month from current to future
        // Except piece fusioned
        const isPast = isAfter(moment().format("MM/YYYY"), item.magicMonth, "MM/YYYY");
        if (!isPast && monthList.indexOf(item.magicMonth) < 0) {
            monthList.push(item.magicMonth);
        }
    });
    // Sort list months
    // if (monthList.length < 1) {
    //     setConfigModal({
    //         message: "Hiện tại bạn không có mảnh ghép nào, quay thưởng ngay để thu thập các mảnh ghép nhé",
    //         btnLabel: "Quay thưởng ngay",
    //         callback: () => {
    //             onCloseModal();
    //             openModal(null);
    //         }
    //     });
    //     openModal(MODAL_TYPE.UN_EXPECTED);
    // } else {
    monthList.sort(compareMonth);
    // }

    const fusion = async () => {
        if (loading) return;
        setLoading(true);
        const result = await magicRewardReception({ gameCode: gameCode, magicMonth: monthList[currentMonthIndex] });
        setLoading(false);
        if (result && result.result.ok && result.data) {
            handleNativeAction(NATIVE_ACTION.INS_QUAYONG_GHEPMANH_SUCCESS, { ins_transaction_type: monthList[currentMonthIndex] });
            setFustionData(result.data);
            openModal(MODAL_TYPE.FUSION);
        } else {
            // Ghép mảnh thất bại
            setCurrentMonthIndex(0);
            openModal(MODAL_TYPE.UN_EXPECTED);
        }
        // // Testing
        // setFustionData({
        //     "message": "Ghép mảnh thành công! Bạn đã giật được giải đặc biệt tháng này với trị giá 10000000 VNĐ. Giải thưởng sẽ được hệ thống gửi tới bạn sau ít phút.",
        //     "rewardMoney": 999999999
        // });
        // openModal(MODAL_TYPE.FUSION);
    }

    const handleChangeSlide = (previous, current) => {
        if (previous < current) {
            setCurrentMonthIndex(currentMonthIndex + 1);
        } else {
            setCurrentMonthIndex(currentMonthIndex - 1);
        }
    }

    const getMagicMonthList = month => {
        const list = magicList.filter(item => item.magicMonth === month);
        return list;
    }

    return (
        <>
            {!modal && <Modal open={isOpen} onClose={onCloseModal} gameCode={gameCode}>
                <div className='h-100' style={{ padding: "0 1.625rem 0 1.25rem" }}>
                    <div className='flex justify-content-between  relative z-[10000] top-[1.25rem]'>
                        <img src={icInfo} onClick={() => openModal(MODAL_TYPE.INFO)} alt="button info" style={{ width: "5rem", height: "1.625rem" }} />
                        <img className="w-[36px] h-[36px] icon-header" src={icClose} onClick={() => onCloseModal()} alt="button close" />
                    </div>
                    <Container className='px-3'>
                        <Container className='relative' style={{ minWidth: "100%", top: "1rem" }}>
                            <img src={imgBuc} style={{ ...styleCenter, bottom: ".75rem" }} alt="img-buc" />

                        </Container>

                        <Content className=''>
                            <Carousel
                                additionalTransfrom={0}
                                arrows
                                autoPlaySpeed={3000}
                                centerMode={false}
                                className="custom-carousel"
                                containerClass=""
                                dotListClass=""
                                draggable
                                focusOnSelect={false}
                                // infinite
                                itemClass=""
                                keyBoardControl
                                minimumTouchDrag={80}
                                pauseOnHover
                                // customRightArrow={<CustomRightArrow />}
                                // customLeftArrow={<CustomLeftArrow />}
                                renderArrowsWhenDisabled={false}
                                renderButtonGroupOutside={false}
                                renderDotsOutside={false}
                                responsive={{
                                    desktop: {
                                        breakpoint: {
                                            max: 3000,
                                            min: 1024
                                        },
                                        items: 1
                                    },
                                    mobile: {
                                        breakpoint: {
                                            max: 464,
                                            min: 0
                                        },
                                        items: 1
                                    },
                                    tablet: {
                                        breakpoint: {
                                            max: 1024,
                                            min: 464
                                        },
                                        items: 1
                                    }
                                }}
                                rewind={false}
                                rewindWithAnimation={false}
                                rtl={false}
                                shouldResetAutoplay
                                showDots={false}
                                sliderClass=""
                                slidesToSlide={1}
                                swipeable
                                afterChange={(previousSlide, { currentSlide, onMove }) => {
                                    handleChangeSlide(previousSlide, currentSlide);
                                }}
                            >
                                {monthList.map((month, index) => <Image magicInMonth={getMagicMonthList(month)} fusion={() => fusion()} key={index} />)}
                            </Carousel>
                        </Content>
                    </Container>
                </div>

            </Modal>}
            {isOpen && !modal && <DropBanner customClass="drop-top" title={DROP_TITLE[MODAL_TYPE.FUSION]} />}
            {modal === MODAL_TYPE.FUSION && <ModalFusion isOpen={modal === MODAL_TYPE.FUSION}
                onCloseModal={(history) => {
                    openModal(null);
                    if (history.length > 0) {
                        setCurrentMonthIndex(0);
                        setMagicList(history);
                    } else {
                        setConfigModal({
                            message: "Hiện tại bạn không có mảnh ghép nào, quay thưởng ngay để thu thập các mảnh ghép nhé",
                            btnLabel: "Quay thưởng ngay",
                            callback: () => {
                                openModal();
                                onCloseModal();
                            }
                        });
                        openModal(MODAL_TYPE.UN_EXPECTED);
                    }
                }}
                data={fusionData}
                gameCode={gameCode} />
            }
            <ModalUnexpected
                isOpen={modal === MODAL_TYPE.UN_EXPECTED}
                onCloseModal={configUnexpected.callback}
                message={configUnexpected.message}
                btnLabel={configUnexpected.btnLabel}
                gameCode={gameCode} />
            <ModalInfo
                isOpen={modal === MODAL_TYPE.INFO}
                onCloseModal={() => openModal(null)}
                gameCode={gameCode}
                content={
                    <>
                        <p><strong>1. Cách tham gia Mảnh ghép may mắn:</strong></p>
                        <p>Bước 1: Thu thập đủ 4 mảnh ghép trong tháng.</p>
                        <p>Bước 2: Đến Kho mảnh ghép để ghép các mảnh lại với nhau.</p>
                        <p>Bước 3: Nhấn nút Nhận thưởng để nhận giải thưởng.</p>
                        <br />

                        <p><strong>2. Quy định về giải thưởng:</strong></p>
                        <p style={{ marginLeft: "1rem" }}>&#8226; Mỗi tháng có 10 giải thưởng.</p>
                        <p style={{ marginLeft: "1rem" }}>&#8226; Nếu tháng trước còn giải chưa có người ghép mảnh, số giải đó sẽ được chuyển sang tháng sau.</p>
                        <p style={{ marginLeft: "1rem" }}>&#8226; Người đầu tiên ghép thành công 4 mảnh trong tháng sẽ nhận được:</p>
                        <p>Giải thưởng của tháng hiện tại</p>
                        <p>Các giải chưa có người ghép từ tháng trước (nếu có)</p>

                        <br />

                        <p><i>Ví dụ: Tháng 8 còn 2 giải chưa được ghép với tổng giá trị là 9.999.999 x 2 = 19.999.998 VNĐ. Người đầu tiên ghép thành công của tháng 9 sẽ nhận được 9.999.999 + 19.999.998 = 29.999.997 VNĐ.</i></p>
                    </>}
            />

            {loading && <Loading className="overlay">
                <Spinner className="spinner" />
            </Loading>}
        </>
    );
}

const mapDispatchToProps = dispatch => ({
    magicRewardReception: params => dispatch(magicRewardReception(params))
});

export default connect(null, mapDispatchToProps)(PuzzleStorage);